<template>
  <div>
    <div class="d-flex justify-end mb-4">
      <v-btn @click="openPrecificationModal" small color="primary" depressed>
        Nova Precificação
      </v-btn>
    </div>
    <v-alert v-if="error" type="error" dense text>
      {{ error }}
    </v-alert>

    <v-card outlined v-if="activePrecification" rounded="lg" class="pa-4">
      <PrecificationDetails
        :precification="activePrecification"
        @copy="copyPrecification"
      />
    </v-card>
    <v-alert v-else type="warning" text class="mb-0">
      <h6 class="mb-0">Nenhuma precificação ativa.</h6>
      Crie uma nova precificação para começar a gerar faturas.
    </v-alert>

    <template v-if="inactivePrecifications.length > 0">
      <h6 class="mt-4">Inativas</h6>
      <v-expansion-panels>
        <v-expansion-panel
          v-for="precification in inactivePrecifications"
          :key="precification.id"
        >
          <v-expansion-panel-header>
            <span class="font-weight-bold">{{ precification.name }}</span>
            <v-chip label small color="secondary" class="ml-2 flex-grow-0 mr-2">
              Inativa
            </v-chip>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <PrecificationDetails
              :precification="precification"
              :hideHeader="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <PrecificationModal :company="company" @success="loadPrecifications" />
  </div>
</template>

<script>
import COMPANY from "@/services/ultimate/company";
import PrecificationModal from "./precification/PrecificationModal.vue";
import PrecificationDetails from "./precification/PrecificationDetails.vue";

export default {
  name: "CompanyPrecification",
  data: () => ({
    loading: false,
    error: null,
    precifications: [],
  }),
  methods: {
    async loadPrecifications() {
      try {
        this.loading = true;
        this.error = null;
        const data = await COMPANY.getPrecifications(this.company.id);
        this.precifications = data.precifications;
      } catch (error) {
        this.error = error.message || "Erro ao buscar precificações";
      } finally {
        this.loading = false;
      }
    },
    openPrecificationModal() {
      this.$emit("precification-modal", null);
    },
    copyPrecification(precification) {
      this.$emit("precification-modal", {
        ...precification,
        id: undefined,
        Rules: undefined,
        rules: precification.Rules.map((rule) => ({
          itemKey: rule.itemKey,
          pricingType: rule.pricingType,
          config: rule.config,
        })),
      });
    },
  },
  computed: {
    activePrecification() {
      return this.precifications.find(
        (precification) => precification.isActive
      );
    },
    inactivePrecifications() {
      return this.precifications.filter(
        (precification) => !precification.isActive
      );
    },
  },
  watch: {
    "company.id": {
      handler(newVal) {
        this.loadPrecifications();
      },
      immediate: true,
    },
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.loadPrecifications();
  },
  components: {
    PrecificationModal,
    PrecificationDetails,
  },
};
</script>
